import MenuBar from './Menu/MenuBar';
import './Header.scss';

const HeaderComponent = () => {
  return <>
        <MenuBar />
        </>
};

export default HeaderComponent;
